/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getBuyConfigFromProps } from '../helpers';
import type { MoonPayBuyProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

export function MoonPayBuyWidget(props: MoonPayBuyProps) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getBuyConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: props.signature || '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
